var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D1E040",
    d: "M20.498 13.966H1.308C.589 13.966 0 13.392 0 12.69V1.276C0 .574.59 0 1.31 0h19.189c.72 0 1.308.574 1.308 1.276V12.69c0 .702-.588 1.276-1.308 1.276",
    transform: "translate(.368 .445)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A7054",
    d: "M0 .863C0 .388.589 0 1.309 0h19.188c.72 0 1.31.388 1.31.863l-8.343 6.47c-1.42 1.102-4.005 1.09-5.4-.026L0 .863z",
    transform: "translate(.368 .445)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f14a500fa5a0dab041869929aed5b8e0.svg";
export { ForwardRef as ReactComponent };